import { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
function Header() {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlNavbar);
      return () => {
        window.removeEventListener("scroll", controlNavbar);
      };
    }
  }, [lastScrollY]);

  const controlNavbar = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > lastScrollY) {
        setShow(false);
      } else {
        setShow(true);
      }
      setLastScrollY(window.scrollY);
    }
  };

  return (
    <div className={`Header ${!show ? "Scrolled" : ""}`}>
      <Container>
      </Container>
    </div>
  );
}

export default Header;
